import { perUserDismissedFlag } from '@/utils/global/perUserDismissedFlag'

/**
 * Whether a user has already seen and confirmed the "Remove background with
 * AI" price and consent dialog on this browser. The dialog is shown before
 * the first generation; after that its explanation is skipped, so a
 * returning designer is not re-asked every time, but every later removal
 * still starts from a shorter screen that shows the price.
 */
const disclosureDismissed = perUserDismissedFlag(
  'mdl.backgroundRemoval.disclosureDismissed.',
  'true',
)

/** True when this user already confirmed the disclosure on this browser. */
export const hasDismissedBackgroundRemovalDisclosure =
  disclosureDismissed.isDismissed

/** Remember that this user confirmed the disclosure, so later runs skip it. */
export const rememberBackgroundRemovalDisclosureDismissed =
  disclosureDismissed.remember
